'use client'

import { useEffect } from 'react'

const EmbedOpinary = ({ opinaryId }: { opinaryId: string }) => {
  useEffect(() => {
    const opinaryScriptId = 'opinary-embed'
    let opinaryScriptElem = window.document.getElementById(opinaryScriptId) as HTMLScriptElement

    if (!opinaryScriptElem) {
      opinaryScriptElem = document.createElement('script')
      opinaryScriptElem.id = opinaryScriptId
      opinaryScriptElem.async = true
      opinaryScriptElem.src = 'https://widgets.opinary.com/embed.js'

      document.head.appendChild(opinaryScriptElem)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <div className="opinary-widget-embed" data-poll={opinaryId} data-customer="ntv"></div>
}

export default EmbedOpinary
